import { useTranslationX } from 'i18n';
import { Button } from 'components/ui';

import styles from './Success.module.scss';

type Props = {
  onClose: () => void;
};

const Success = ({ onClose }: Props) => {
  const { tx } = useTranslationX('play.auth.done');

  return (
    <div className={styles.success}>
      <Button style={{ root: { height: '2.2rem', width: '100%' } }} onClick={onClose}>
        {tx('button')}
      </Button>
    </div>
  );
};

export default Success;
